(function () {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .directive('sodDocumentLibraryGoogleDoc', sodDocumentLibraryGoogleDoc);

    function sodDocumentLibraryGoogleDoc($timeout, ActionManager) {
        return {
            restrict: 'E',
            controllerAs: 'vm',
            bindToController: true,
            controller: sodDocumentLibraryGoogleDocCtrl,
            scope: {
                url: '=',
                mimeType: '=',
                download: '=?',
                notifyLabel: '@?',
                refresh: '=?',
            },
            templateUrl: 'common/app/components/google-doc-viewer', //
            link: sodDocumentLibraryGoogleDocLink
        };

        function sodDocumentLibraryGoogleDocLink(scope, elem) {
            var vm = scope.vm;
            vm.show = true;
            vm.downloadFile = downloadFile;
            const imageMimeType = [
                'image/jpeg',
                'image/png',
                'image/gif'
            ];
            const pdfMimeType = [
                'application/pdf',
                // 'application/rtf',
            ];

            const docViewerElem = elem.find('.google-doc-file-viewer');

            vm.refresh = function() {
                docViewerElem.empty();
                $timeout(function() {
                    generateDom();
                })
            };

            $timeout(function () {
                generateDom();
            });

            function generateDom() {
                if (imageMimeType.indexOf(scope.vm.mimeType) >= 0) {
                    // images
                    docViewerElem.append('<div><img src="' + scope.vm.url + '" /></div>');
                } else {
                    if (pdfMimeType.indexOf(scope.vm.mimeType) >= 0) {
                        // const pdfObject = `<object type="application/pdf" data="${scope.vm.url}" width="100%" height="100%"><p>This browser does not support PDFs. Please download the PDF to view it: <a href="${scope.vm.url}">Download PDF</a>.</p></object>`;
                        // docViewerElem.append(pdfObject);
                        PDFObject.embed(scope.vm.url, docViewerElem);

                    } else {
                        const iframeDom = '<iframe src="' + scope.vm.url + '" style="width:100%; height:100%;" frameborder="0"></iframe>';
                        // const iframeDom = '<iframe src="' + scope.vm.url + '" style="width:100%; height:100%;" frameborder="0"></iframe>';
                        docViewerElem.append(iframeDom);
                    }
                }
            }

            function downloadFile() {
                ActionManager('notify', {
                    'template': vm.notifyLabel || 'Please wait while we prepare your download...',
                    'hasDelay': true,
                    'delay'   : 2000,
                    'type'    : 'success',
                    'position': 'top center'
                });
                ActionManager('download', { route: vm.download });
                // const iframeDom = docViewerElem.find('iframe')[0];
                // var idoc = iframeDom.contentDocument || iframeDom.contentWindow.document; // ie compatibility
                //
                // idoc.getSelection();
            }
        }
    }

    function sodDocumentLibraryGoogleDocCtrl() {

    }
})();